import { signIn } from './signIn';

export async function signInEmployee(): Promise<void> {
  try {
    await signIn({ isEmployee: true });
  } catch (ex) {
    console.error('[signInEmployee] Error during Employee sign-in:', ex);
  }
}
